var render = function render(){var _vm=this,_c=_vm._self._c;return _c('payment-method-list',{attrs:{"organization-id":_vm.organizationId},scopedSlots:_vm._u([{key:"actions",fn:function(){return [_c('audit-trail-button',{attrs:{"entity-type":"PaymentMethod","organization-id":_vm.organizationId}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }